import { useState, useCallback } from "react";

/**
 * Hook para manejar el estado y lógica del Modal de Resultados
 * @param {Object} options - Opciones del hook
 * @param {Function} options.onClose - Callback al cerrar el modal
 * @param {Function} options.onAccept - Callback al aceptar/entendido
 * @returns {Object} Estados y handlers del modal
 */
export const useModalResultado = ({ onClose, onAccept }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    /**
     * Handler para expandir/colapsar la lista de errores
     */
    const toggleExpand = useCallback(() => {
        setIsExpanded((prev) => !prev);
    }, []);

    /**
     * Handler para cerrar el modal
     */
    const handleClose = useCallback(() => {
        setIsExpanded(false);
        onClose?.();
    }, [onClose]);

    /**
     * Handler para el botón de aceptar
     */
    const handleAccept = useCallback(() => {
        setIsExpanded(false);
        onAccept?.();
    }, [onAccept]);

    return {
        // Estados
        isExpanded,

        // Handlers
        toggleExpand,
        handleClose,
        handleAccept,
    };
};
